export default __webpack_public_path__ + "static/media/venesh_logo_1.621c022d.png";